const ADD_ANIME_WATCHLIST_START = 'ADD_ANIME_WATCHLIST_START';
const ADD_ANIME_WATCHLIST_SUCCESS = 'ADD_ANIME_WATCHLIST_SUCCESS';
const ADD_ANIME_WATCHLIST_FAIL = 'ADD_ANIME_WATCHLIST_FAIL';
const GET_ANIME_WATCHLIST_SUCCESS = 'GET_ANIME_WATCHLIST_SUCCESS';
const GET_ANIME_WATCHLIST_FAIL = 'GET_ANIME_WATCHLIST_FAIL';
const SET_ANIME_ID = 'SET_ANIME_ID';
const DELETE_ANIME_WATCHLIST_START = 'DELETE_ANIME_WATCHLIST_START';
const DELETE_ANIME_WATCHLIST_SUCCESS = 'DELETE_ANIME_WATCHLIST_SUCCESS';
const DELETE_ANIME_WATCHLIST_FAIL = 'DELETE_ANIME_WATCHLIST_FAIL';
const SET_ANIME_DIALOG_DETAIL = 'SET_ANIME_DIALOG_DETAIL';
const ANIME_STATUS_SAVE_START = 'ANIME_STATUS_SAVE_START';
const ANIME_STATUS_SAVE_SUCCESS = 'ANIME_STATUS_SAVE_SUCCESS';
const ANIME_STATUS_SAVE_FAIL = 'ANIME_STATUS_SAVE_FAIL';
const SET_ANIME_FILTER = 'SET_ANIME_FILTER';
const GET_ANIME_DETAILS_START = 'GET_ANIME_DETAILS_START';
const GET_ANIME_DETAILS_SUCCESS = 'GET_ANIME_DETAILS_SUCCESS';
const GET_ANIME_DETAILS_FAIL = 'GET_ANIME_DETAILS_FAIL';
const GET_ANIME_REVIEW_START = 'GET_ANIME_REVIEW_START';
const GET_ANIME_REVIEW_SUCCESS = 'GET_ANIME_REVIEW_SUCCESS';
const GET_ANIME_REVIEW_FAIL = 'GET_ANIME_REVIEW_FAIL';
const SET_ANIME_VIDEO_URL_START = 'SET_ANIME_VIDEO_URL_START';
const SET_ANIME_VIDEO_URL_SUCCESS = 'SET_ANIME_VIDEO_URL_SUCCESS';
const SET_ANIME_VIDEO_URL_FAIL = 'SET_ANIME_VIDEO_URL_FAIL';

export {
  ADD_ANIME_WATCHLIST_START,
  ADD_ANIME_WATCHLIST_SUCCESS,
  ADD_ANIME_WATCHLIST_FAIL,
  GET_ANIME_WATCHLIST_FAIL,
  GET_ANIME_WATCHLIST_SUCCESS,
  SET_ANIME_ID,
  DELETE_ANIME_WATCHLIST_START,
  DELETE_ANIME_WATCHLIST_SUCCESS,
  DELETE_ANIME_WATCHLIST_FAIL,
  SET_ANIME_DIALOG_DETAIL,
  ANIME_STATUS_SAVE_START,
  ANIME_STATUS_SAVE_SUCCESS,
  ANIME_STATUS_SAVE_FAIL,
  SET_ANIME_FILTER,
  GET_ANIME_DETAILS_START,
  GET_ANIME_DETAILS_SUCCESS,
  GET_ANIME_DETAILS_FAIL,
  GET_ANIME_REVIEW_START,
  GET_ANIME_REVIEW_SUCCESS,
  GET_ANIME_REVIEW_FAIL,
  SET_ANIME_VIDEO_URL_START,
  SET_ANIME_VIDEO_URL_SUCCESS,
  SET_ANIME_VIDEO_URL_FAIL,
};
